module.exports = __webpack_public_path__ + "media/control_acceso/layout-f46e6532.png";